module.exports = {};



//////////////////
// WEBPACK FOOTER
// ./~/babel-polyfill/~/core-js/modules/_iterators.js
// module id = 279
// module chunks = 18 22